<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_21"></a><a id="pg21lev1"></a><img alt="Baked goat’s cheese cigars with melon, radish, and cucumber slaw" src="images/f0021-01.jpg"/></h2>
<p class="recipe_hdnote">The Nice area in France tends to produce goat’s cheese rather than cheese made from cow’s milk, as the landscape is too rugged and rough for cows to graze. Eating goat’s cheese from this region really captures the flavors of the terroir. Goats graze on whatever grows, from wild herbs, such as oregano and thyme, to berries, and these flavors subtly influence the end product. These cigars make a delectable summer starter or an aperitif with a glass of rosé, showcasing the flavors of Provence.</p>
<div class="wrap">
<p class="image"><a id="page_20"></a><img alt="image" class="vertical" src="images/f0020-01.jpg"/></p>
</div>
<p class="yield">Serves 4 as a starter</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Preparation time: 20 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Cooking time: 15 to 20 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="left">For the cigars</p>
<p class="ingred_sublist">1 to 2 rectangular filo sheets (depending on the size of your sheets)</p>
<p class="ingred_sublist">4 tbsp butter, melted</p>
<p class="ingred_sublist">leaves from 8 sprigs of thyme</p>
<p class="ingred_sublist">4<sup>1</sup>/<sub>2</sub> oz soft goat’s cheese</p>
<p class="ingred_sublist">4 tsp honey (lavender, if possible)</p>
<p class="left">For the slaw</p>
<p class="ingred_sublist">1 small cucumber or <sup>1</sup>/<sub>2</sub> regular cucumber</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>2</sub> unripe galia melon, seeded</p>
<p class="ingred_sublist">6 radishes, trimmed and sliced into thin rounds</p>
<p class="left">For the dressing</p>
<p class="ingred_sublist">1 tbsp extra-virgin olive oil</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>2</sub> tbsp red wine vinegar</p>
<p class="ingred_sublist">sea salt and freshly ground pepper</p>
<p class="method_txt">To make the cigars: Preheat the oven to 350°F. Line a baking sheet with parchment paper.</p>
<p class="method_txt">Unroll a sheet of filo horizontally on your work surface. Cut the filo sheet in half lengthwise and in half crosswise to make four rectangles measuring about 6 by 8 in. Lay them all out on the work surface, then brush the rectangles generously with the butter, reserving about 1 tbsp to brush the tops.</p>
<p class="method_txt">Sprinkle some thyme leaves along the long length of each pastry and fold it in about <sup>3</sup>/<sub>4</sub> in to encase them. Crumble the goat’s cheese in a line along the opposite short side of the pastry. Drizzle the honey along the goat’s cheese on each pastry. Starting at the goat’s cheese end, roll the pastry over the cheese and all the way to the thyme, pressing gently to seal. Repeat the process to make four cigars. Place on the prepared baking sheet and brush with the remaining butter. Bake for 15 to 20 minutes, or until golden and crisp.</p>
<p class="method_txt">To make the slaw: Using a mandoline or speed peeler, julienne the cucumber and the melon flesh. Place them in a bowl and add the radishes.</p>
<p class="method_txt">To make the dressing: Combine the ingredients in a jam jar and shake to mix well.</p>
<p class="method_txt">Once the cigars are baked, toss the slaw with the dressing and place in the center of each plate. Serve with the cigars on top.</p>
<p class="sidebar2_hd">Tips</p>
<p class="sidebar1_txt"><em>Filo sheets dry out quickly. Be sure to store them in plastic wrap. Be gentle when brushing the sheets, as they can tear easily</em>.</p>
<p class="sidebar1_txt"><em>You can flavor the goat’s cheese with any dried herbs or spices, such as cayenne pepper, smoked paprika, ground cumin, or chile. Or try your favorite chutney or caramelized onions in place of the honey</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10-chapter04.vue?106872a4